export default __webpack_public_path__ + "static/media/noa-38.18a7defc.jpg";